import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=14dc557b"
import script from "./ProvidersList.vue?vue&type=script&lang=js"
export * from "./ProvidersList.vue?vue&type=script&lang=js"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=14dc557b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports